import { createFileRoute } from "@tanstack/react-router";
import { ControlChartParentGroupInspectingView } from "src/components/views/spc/controlChart/parentGroupInspectingView/ControlChartParentGroupInspectingView.tsx";
import { UserControlChartParentGroupsApi } from "src/api/generated/spc/controlChart/api/userControlChartParentGroupsApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/spc/controlChartParentGroup/$parentGroupId")({
	staticData: {
		legacyViewKey: "controlChartParentGroupsGeneratedPages",
		listGeneratedViews: async () =>
			(await UserControlChartParentGroupsApi.getUserControlChartParentGroups()).map((parentGroup) => ({
				id: parentGroup.id,
				title: parentGroup.name,
			})),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id },
		isActive,
	} = useKeptAliveGeneratedView();
	return <ControlChartParentGroupInspectingView parentGroupId={id} isActive={isActive} />;
}
